<template>
  <el-drawer class="drawer" ref="drawer" :title="title" :visible.sync="drawer" :direction="direction" :destroy-on-close="true" :before-close="handleClose" @opened="getlist" :size="size">
    <!-- 手风琴 -->
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item v-for="(rowItem,index) in sourceList" :title="rowItem.title" :name="rowItem.name" :key="index" :disabled="sourceList.length == 1" :class="sourceList.length == 1?'disabled':''">
        <div class="box">
          <!-- 待选 -->
          <el-card class="box-card card-left">
            <div slot="header" class="clearfix">
              <span>{{rowItem.toSelectedList.title}}</span>
              <el-button style="float: right; padding: 3px 0" type="text" :disabled="rowItem.toSelectedList.disabledSearch" @click="handleSelectAll(rowItem, index)">全选</el-button>
            </div>
            <el-input class="filter-item" size="mini" v-model="rowItem.toSelectedList.search" @input="changeToSearch($event,index)" clearable placeholder="输入关键字搜索"></el-input>
            <!-- 树形控件 -->
            <div class="list" v-loading="rowItem.toSelectedList.treeload">
              <el-scrollbar wrap-class="scrollbar-wrapper">
                <!-- 不关联 :lazy="rowItem.types && rowItem.types==6" :load="loadNode" @node-expand="nodeExpand"-->
                <el-tree :lazy="rowItem.types && rowItem.types==6" @node-expand="(data,node,event)=>{nodeExpand(data,node,event,rowItem.types)}" v-if="rowItem.checkStrictly" :ref="'toTree-'+index" node-key="id"
                  :data="rowItem.toSelectedList.list" :props="rowItem.types==6?defaultProps6:defaultProps" check-strictly show-checkbox @check-change="handleCheckChange" @check="handleCheck($event,index)"
                  :filter-node-method="filterNode">
                  <span v-if="source == 'groups'" style="font-size:14px;" slot-scope="{data}" :title="data.name +' - '+ data.desc">{{data.name}} - {{data.desc}}</span>
                  <span v-else-if="source == 'purview' || rowItem.source == 'purview'" style="font-size:14px;" slot-scope="{data}" :title="data.name +' - '+ data.title">{{data.name}} - {{data.title}}</span>
                  <span v-else-if="source == 'userGroup'" style="font-size:14px;" slot-scope="{data}" :title="data.realname +' - '+ data.email">{{data.realname}} - {{data.email}}</span>
                  <span v-else-if="source == 'batch-purview' ||  rowItem.source == 'batch-purview'" style="font-size:14px;" slot-scope="{data}" :title="data.permissionValue +' - '+ data.name">{{data.permissionValue}} -
                    {{data.name}}</span>
                </el-tree>

                <!-- 关联 -->
                <el-tree v-else :ref="'toTree-'+index" node-key="id" :data="rowItem.toSelectedList.list" :props="defaultProps" show-checkbox @check="handleCheck($event,index)" :filter-node-method="filterNodeStrictly">
                  <span style="font-size:14px;" slot-scope="{data}" :title="data.permissionValue +' - '+ data.name">{{data.permissionValue}} - {{data.name}}</span>
                </el-tree>
              </el-scrollbar>
            </div>
          </el-card>

          <!-- 已选 -->
          <el-card class="box-card card-right">
            <div slot="header" class="clearfix">
              <span>{{rowItem.selectedList.title}}</span>
              <el-button style="float: right; padding: 3px 0;" type="text" :disabled="rowItem.selectedList.disabledSearch" @click="handleEmpty(rowItem, index)">清空</el-button>
            </div>
            <el-input class="filter-item" size="mini" v-model="rowItem.selectedList.search" @input="changeSearch($event,rowItem)" clearable placeholder="输入关键字搜索"></el-input>

            <div class="list">
              <el-scrollbar wrap-class="scrollbar-wrapper">
                <div class="item" v-for="item in rowItem.selectedList.list" :key="item.id">
                  <span v-if="source == 'groups'">{{item.name}} - {{item.desc}}</span>
                  <span v-else-if="source == 'purview' || rowItem.source == 'purview'">{{item.name}} - {{item.title}}</span>
                  <span v-else-if="source == 'userGroup'">{{item.realname}} - {{item.email}}</span>
                  <span v-else-if="source == 'batch-purview' ||  rowItem.source == 'batch-purview'">{{item.permissionValue}} - {{item.name}}</span>

                  <el-button v-if="rowItem.checkStrictly" size="mini" type="danger" icon="el-icon-delete" circle @click="treetabledelete(rowItem, index, item)"></el-button>
                </div>
              </el-scrollbar>
            </div>
          </el-card>

        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="dialog-butn-box" style="margin: 20px">
      <el-button size="mini" type="primary" :loading='butnLoading' @click="handleSave">确认</el-button>
      <el-button size="mini" @click="handleClose">关闭</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { permissionfilterHas } from '@Sys~/api/sys'
export default {
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 弹框大小
    size: {
      type: String,
      default: '700px'
    },
  },

  data() {
    return {
      drawer: false, // 弹窗
      butnLoading: false, // 确定loding
      direction: 'rtl',

      activeName: '1', // 手风琴

      source: '', // 来源
      specialSource: '', // 特殊来源
      rowInfo: {}, // 当前数据列详情

      sourceList: [
        {
          title: '', // Collapse 折叠面板 标题
          name: '1', // Collapse 折叠面板 序号
          checkStrictly: false, // tree 的类型 false关联 true不关联
          toSelectedList: { // 待选数据
            title: '待选', // 待选标题
            search: '',
            disabledSearch: true,
            treeload: false,
            list: []
          },
          selectedList: { // 已选数据
            title: '已选',
            search: '',
            disabledSearch: true,
            treeload: false,
            rawList: [], // 记录原始数据
            list: []
          }
        },
      ],

      defaultProps: {
        children: 'childs',
        label: 'name',
      },
      defaultProps6: {
        children: 'childs',
        label: 'name',
        isLeaf: 'leaf'
      },
    }
  },

  methods: {
    // 初始化
    init(source, row, specialSource) {
      this.drawer = true
      this.butnLoading = false // 确定loding
      this.activeName = '1' // 手风琴

      this.source = source
      this.specialSource = specialSource
      this.rowInfo = row
    },

    // 获取数据列表
    getlist() {
      if (this.source == 'batch-purview' || this.source == 'batch') {
        this.$emit("getTransferList", this.source, this.rowInfo, 2, this.specialSource) // 菜单
        if (process.env.VUE_APP_PROJECT_TYPE == 'ads') {
          this.$emit("getTransferList", this.source, this.rowInfo, 5, this.specialSource) // 媒体
          if (this.source == 'batch-purview' && this.specialSource !== 'batch-purview') {
            this.$emit("getTransferList", this.source, this.rowInfo, 6, this.specialSource) // 监测
          }
          this.$emit("getTransferList", this.source, this.rowInfo, 7, this.specialSource) // 指标
          this.$emit("getTransferList", this.source, this.rowInfo, 8, this.specialSource) // 用户来源
        } else if (process.env.VUE_APP_PROJECT_TYPE == 'file') {
          console.log("process.env.VUE_APP_PROJECT_TYPE == 'file'")
          this.$emit("getTransferList", this.source, this.rowInfo, 1) // 功能点
          this.$emit("getTransferList", this.source, this.rowInfo, 9) // 部门
          this.$emit("getTransferList", this.source, this.rowInfo, 10) // 外包商
        } else {
          this.$emit("getTransferList", this.source, this.rowInfo, 4) // 渠道
          this.$emit("getTransferList", this.source, this.rowInfo, 12) // 国家
        }

        if (this.source == 'batch') {
          this.$emit("getTransferList", this.source, this.rowInfo) // 角色
        }
      } else {
        this.$emit("getTransferList", this.source, this.rowInfo)
      }
    },
    nodeExpand(data, node, event, v) {
      if (v != 6) {
        return false
      }

      if (data.childs && data.childs.length == 0) {
        node.loading = true
        permissionfilterHas(this.rowInfo.id, data.status, data.menuId).then(response => {
          data.childs = this.transformList(response.data)
          node.loading = false
        });
      }

    },

    // 转换待选列表
    transformList(list) {
      let data = []
      if (list && list.length > 0) {
        data = list.map(f => {
          f.disabled = false
          if (f.childs && f.childs.length > 0) {
            this.transformList(f.childs)
          } else {
            f.childs = []
          }

          if (!f.id) {
            f.id = ''
          }
          return f
        })
      }

      return data
      // console.log('====',this.toData)
    },

    // 监听待选 input 搜索框
    changeToSearch(val, index) {
      // console.log(val, index)
      const toTree = 'toTree-' + index
      this.$refs[toTree][0].filter(val);
      if (val) {
        this.sourceList[index].toSelectedList.disabledSearch = true
      } else {
        this.sourceList[index].toSelectedList.disabledSearch = false
      }
    },

    // 筛选
    filterNode(value, data) {
      // console.log('value:',value, 'data:',data)
      //console.log('非关联关系')
      if (!value) return true;
      if (this.source == 'groups') {
        if (data.name != null && data.desc != null) {
          return data.name.indexOf(value) !== -1 || data.desc.indexOf(value) !== -1
        } else if (data.name != null) {
          return data.name.indexOf(value) !== -1
        } else if (data.desc != null) {
          return data.desc.indexOf(value) !== -1
        }
      } else if (this.source == 'purview' || this.source == 'batch') {
        if (data.name != null && data.title != null) {
          return data.name.indexOf(value) !== -1 || data.title.indexOf(value) !== -1
        } else if (data.name != null) {
          return data.name.indexOf(value) !== -1
        } else if (data.title != null) {
          return data.title.indexOf(value) !== -1
        }
      } else if (this.source == 'userGroup') {
        if (data.realname != null && data.email != null) {
          return data.realname.indexOf(value) !== -1 || data.email.indexOf(value) !== -1
        } else if (data.realname != null) {
          return data.realname.indexOf(value) !== -1
        } else if (data.email != null) {
          return data.email.indexOf(value) !== -1
        }
      } else if (this.source == 'batch-purview') {
        if (data.permissionValue != null && data.name != null) {
          return data.permissionValue.indexOf(value) !== -1 || data.name.indexOf(value) !== -1
        } else if (data.permissionValue != null) {
          return data.permissionValue.indexOf(value) !== -1
        } else if (data.name != null) {
          return data.name.indexOf(value) !== -1
        }
      }
    },

    filterNodeStrictly(value, data) {
      //console.log('关联关系')
      if (!value) return true;
      if (this.source == 'batch' || this.source == 'batch-purview') {
        if (data.permissionValue != null && data.name != null) {
          return data.permissionValue.indexOf(value) !== -1 || data.name.indexOf(value) !== -1
        } else if (data.permissionValue != null) {
          return data.permissionValue.indexOf(value) !== -1
        } else if (data.name != null) {
          return data.name.indexOf(value) !== -1
        }
      }
    },

    // 监听已选
    changeSearch(val, item) {
      const search = val.toLowerCase().replace(/\s+/g, "");
      if (search) {
        item.selectedList.disabledSearch = true
        // console.log()
        const list = item.selectedList.rawList.filter(data => {

          if (this.source == 'groups') {
            return String(data['name']).toLowerCase().indexOf(search) > -1
              || String(data['desc']).toLowerCase().indexOf(search) > -1
          } else if (this.source == 'purview' || item.source == 'purview') {
            return String(data['name']).toLowerCase().indexOf(search) > -1
              || String(data['title']).toLowerCase().indexOf(search) > -1
          } else if (this.source == 'userGroup') {
            return String(data['realname']).toLowerCase().indexOf(search) > -1
              || String(data['email']).toLowerCase().indexOf(search) > -1
          } else if (this.source == 'batch-purview' || item.source == 'batch-purview') {
            return String(data['permissionValue']).toLowerCase().indexOf(search) > -1
              || String(data['name']).toLowerCase().indexOf(search) > -1
          }
        })
        return item.selectedList.list = list
      } else {
        item.selectedList.disabledSearch = false
      }

      return item.selectedList.list = JSON.parse(JSON.stringify(item.selectedList.rawList))
    },

    // 全选
    handleSelectAll(item, index) {
      let ids = []

      item.toSelectedList.list.forEach(item => {
        ids.push(item.id)
      })
      const toTree = 'toTree-' + index
      this.$refs[toTree][0].setCheckedKeys(ids) // 设置要选项

      const checkedNodes = JSON.parse(JSON.stringify(this.$refs[toTree][0].getCheckedNodes())) // 获取已选节点
      this.exportCheckeds(checkedNodes, index) // 获取最终取值

      // this.sourceList[index].toSelectedList.disabledSearch = true
    },

    // 清空
    handleEmpty(item, index) {
      item.selectedList.rawList = item.selectedList.list = []
      const toTree = 'toTree-' + index
      this.$refs[toTree][0].setCheckedKeys([]) // 设置要选项
      this.sourceList[index].selectedList.disabledSearch = true
      if (!this.sourceList[index].toSelectedList.search) {
        this.sourceList[index].toSelectedList.disabledSearch = false
      }
    },

    // 删除
    treetabledelete(item, index, row) {
      //console.log(item, index, row)
      let ids = []
      item.selectedList.rawList.forEach(son => {
        if (son.id !== row.id) {
          ids.push(son.id)
        }
      })
      const toTree = 'toTree-' + index
      this.$refs[toTree][0].setCheckedKeys(ids) // 设置要选项

      const checkedNodes = JSON.parse(JSON.stringify(this.$refs[toTree][0].getCheckedNodes())) // 获取已选节点
      this.exportCheckeds(checkedNodes, index) // 获取最终取值

      if (!this.sourceList[index].toSelectedList.search) {
        this.sourceList[index].toSelectedList.disabledSearch = false
      }

    },

    // 点击选中框
    handleCheck(e, index) {
      console.log(e, index)
      const toTree = 'toTree-' + index
      const checkedNodes = JSON.parse(JSON.stringify(this.$refs[toTree][0].getCheckedNodes())) // 获取已选节点
      // console.log(checkedNodes)
      this.exportCheckeds(checkedNodes, index)
    },

    // 选中状态变化
    handleCheckChange(e, checked) {
      console.log(e, checked)
      if (checked) {
        this.checkedChilds(e, checked)
      } else {
        if (e.disabled) {
          this.checkedChilds(e, true)
        } else {
          this.checkedChilds(e, checked)
        }
      }
    },

    // 转换选中的子集为禁用状态
    checkedChilds(list, checked) {
      if (list.childs && list.childs.length > 0) {
        list.childs.forEach(c => {
          if (checked) {
            c.disabled = true
          } else {
            c.disabled = false
          }
          if (c.childs && c.childs.length > 0) {
            this.checkedChilds(c, checked)
          }
        })
      }
    },

    // 导出最终已选列表
    exportCheckeds(arr, index) {
      const checkeds = []
      const ids = []
      arr.forEach(a => {
        if (a.disabled == false) {
          checkeds.push(a)
          ids.push(Number(a.id))
        }
      })
      if (this.sourceList[index].selectedList.search) {
        this.sourceList[index].selectedList.rawList = checkeds
        this.changeSearch(this.sourceList[index].selectedList.search, this.sourceList[index])
      } else {
        this.sourceList[index].selectedList.rawList = this.sourceList[index].selectedList.list = checkeds // 最终结果
      }

      // 设置最终选中的样式
      const toTree = 'toTree-' + index
      this.$refs[toTree][0].setCheckedKeys(ids) // 设置要选项

      // 设置已选清空按钮的点击状态
      if (this.sourceList[index].selectedList.list.length > 0 && !this.sourceList[index].selectedList.search) {
        this.sourceList[index].selectedList.disabledSearch = false
      } else {
        this.sourceList[index].selectedList.disabledSearch = true
      }

      // 设置待选 全选的按钮状态 
      // if(this.sourceList[index].toSelectedList.list.length == arr.length) {
      //     this.sourceList[index].toSelectedList.disabledSearch = true
      // } else {
      //     this.sourceList[index].toSelectedList.disabledSearch = false
      // }
    },

    // 关闭
    handleClose(done) {
      if (typeof done == 'function') {
        done();
      } else {
        this.$refs['drawer'].closeDrawer()
      }
    },

    // 确认
    handleSave() {
      this.butnLoading = true
      this.$emit('handleSave', this.sourceList, this.rowInfo, this.source)
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 10px;
  }
  ::v-deep .el-drawer__body {
    // padding: 0 20px;
  }
  ::v-deep .el-collapse-item__header {
    height: 30px;
    line-height: 30px;
    // border-bottom:1px solid #a3d3ff;
    background: #e8f4ff;
    padding: 0 10px 0 20px;
  }

  ::v-deep .el-collapse-item__content {
    padding: 10px 0;
  }

  .disabled {
    ::v-deep .el-collapse-item__header {
      height: 0px;
      line-height: 0px;
    }
    ::v-deep .el-collapse-item__arrow {
      display: none;
    }
  }

  ::v-deep .el-tree-node > .el-tree-node__children {
    overflow: inherit;
  }
}
.box {
  padding: 0 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  .box-card {
    width: 100%;
  }
  .card-left {
    margin-right: 10px;
  }
  .card-right {
    margin-left: 10px;
  }
  ::v-deep .el-card__header {
    padding: 3px 20px;
    line-height: 28px;
  }
  .filter-item {
    width: 100%;
    margin-bottom: 10px;
  }

  ::v-deep :focus {
    outline: 0;
  }

  .list {
    height: calc(100vh - 460px);
    .item {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;
      padding: 5px 10px 5px 0;
    }
  }

  ::v-deep .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }
}

::v-deep :focus {
  outline: 0;
}
</style>